import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './ChatBubble.styled';

const ChatBubble = (props) => {
  return (
    <Styled.Bubble chatType={props.chatType} feedbackText={props.feedbackText}>
      {props.children}
    </Styled.Bubble>
  );
};

ChatBubble.defaultPropTypes = {
  chatType: true,
};

ChatBubble.propTypes = {
  children: PropTypes.node.isRequired,
  chatType: PropTypes.string.isRequired,
  feedbackText: PropTypes.string,
};

export default ChatBubble;
